<div class="wrap">
  <h1>{{ 'pages.user-subscriptions.module-heading' | translate }}</h1>

  <h2>{{ 'pages.user-subscriptions.active-heading' | translate }}</h2>
  <div class="loading-spinner">
    <mat-progress-spinner *ngIf="loading"
      mode="indeterminate"
      diameter="20">
    </mat-progress-spinner>
  </div>
  <div *ngIf="!loading" class="active-subscriptions">
    <app-subscription
      *ngFor="let sub of activeSubscriptions"
      [item]="sub"
      [showContextMenu]="sub['owner'] === true"
      (detailsDialogPrompt)="handleDetailsDialogPrompt($event)"
      (deleteDialogPrompt)="handleDeleteDialogPrompt($event)"
      (renewDialogPrompt)="openRenewalDialog($event)"
      class="active-sub">
    </app-subscription>
    <p *ngIf="!activeSubscriptions.length && !loading">{{ 'pages.user-subscriptions.active-empty' | translate }}</p>
  </div>

  <h2>{{ 'pages.user-subscriptions.inactive-heading' | translate }}</h2>
  <div class="loading-spinner">
    <mat-progress-spinner *ngIf="loading"
      mode="indeterminate"
      diameter="20">
    </mat-progress-spinner>
  </div>
  <div *ngIf="!loading" class="active-subscriptions">
    <app-subscription
      *ngFor="let sub of inactiveSubscriptions"
      [item]="sub"
      [showContextMenu]="true"
      (detailsDialogPrompt)="handleDetailsDialogPrompt($event)"
      (deleteDialogPrompt)="handleDeleteDialogPrompt($event)"
      (renewDialogPrompt)="openRenewalDialog($event)"
      class="active-sub">
    </app-subscription>
    <p *ngIf="!inactiveSubscriptions.length && !loading">{{ 'pages.user-subscriptions.inactive-empty' | translate }}</p>
  </div>

  <h2>{{ 'pages.user-subscriptions.available-heading' | translate }}</h2>
  <div class="loading-spinner">
    <mat-progress-spinner *ngIf="loading"
      mode="indeterminate"
      diameter="20">
    </mat-progress-spinner>
  </div>
  <p *ngIf="!loading" class="instructions">{{ 'pages.user-subscriptions.available-instructions' | translate }}</p>
  <div *ngIf="!loading" class="inactive-subscriptions" [formGroup]="subscribeForm">
    <app-subscription
      *ngFor="let sub of availableSubscriptions"
      [item]="sub"
      [selectable]="true"
      [disableSelect]="sub.status === UserOrgSubscriptionStatus.UNAVAILABLE ? true : false"
      [masterForm]="subscribeForm"
      class="inactive-sub">
    </app-subscription>
  </div>
  <p *ngIf="!availableSubscriptions.length && !loading">{{ 'pages.user-subscriptions.available-empty' | translate }}</p>
  <footer *ngIf="availableSubscriptions.length && !loading">
    <button class="bciti-button"
      [ngClass]="!enablePaymentDialog ? 'bciti-button--disabled' : 'bciti-button--blue'"
      [disabled]="!enablePaymentDialog"
      (click)="openPaymentDialog()">
      {{ 'pages.user-subscriptions.add-subscriptions' | translate }}
    </button>
  </footer>
</div>